import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.6_@types+node@26.0.0_cac@6.7.14_db0@0.3.4_eslint@9.39.4_jiti@_litq45cmvj5p2y2c5663veeyyq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}